<div>
  <div class="sm:flex sm:items-center justify-between">
    <div class="sm:flex-auto">
      <h1 class="text-xl font-semibold text-gray-900">Blacklist Users</h1>
      <p class="mt-2 text-xs text-gray-700">A list of all blacklisted users.</p>
    </div>

    <!-- Add Search Input -->
    <div class="flex items-center gap-4 mt-4 sm:mt-0">
      <div class="relative">
        <input
          type="text"
          placeholder="Email..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
          class="block w-64 rounded-md border border-gray-300 pl-3 pr-10 py-2 text-xs focus:border-indigo-500 focus:ring-indigo-500"
        />
      </div>

    </div>
  </div>

  <!-- Table -->
  <div class="mt-8 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="overflow-hidden shadow md:rounded-lg">
          <table class="min-w-full divide-y divide-gray-300">
            <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">First name</th>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">Last name</th>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">Email</th>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">Nationality</th>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">DOB</th>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">Reason</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr *ngFor="let phoneNumber of blacklistPhoneNumbers">
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ phoneNumber.first_name }}</td>
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ phoneNumber.last_name }}</td>
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ phoneNumber.email }}</td>
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ phoneNumber.nationality }}</td>
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ phoneNumber.date_of_birth }}</td>
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ phoneNumber.reason }}</td>
              </tr>
              <tr *ngIf="submitted || blacklistPhoneNumbers.length === 0">
                <td colspan="8" class="py-6 text-center text-xs text-gray-500">
                  <ng-container *ngIf="submitted; else empty">
                    <div class="flex justify-center items-center gap-2">
                      <div class="w-5 h-5 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                      <span>Loading data...</span>
                    </div>
                  </ng-container>
                  <ng-template #empty>
                    Sorry, we couldn't find any results.
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="mt-8 flex justify-center">
          <nav class="inline-flex shadow-sm rounded-md">
            <button
              (click)="goToPreviousPage()"
              [disabled]="!previousPageUrl"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-l-md hover:bg-gray-50 disabled:opacity-50"
            >
              ‹
            </button>
            <button
              *ngFor="let page of pageNumbers"
              (click)="page !== '...' && goToPage(page)"
              [disabled]="page === '...' || currentPage === page"
              [ngClass]="{
                'bg-indigo-500 text-white': currentPage === page,
                'bg-white text-gray-700': currentPage !== page && page !== '...'
              }"
              class="px-4 py-2 border border-gray-300 text-xs"
            >
              {{ page }}
            </button>
            <button
              (click)="goToNextPage()"
              [disabled]="!nextPageUrl"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-r-md hover:bg-gray-50 disabled:opacity-50"
            >
              ›
            </button>
          </nav>
        </div>

      </div>
    </div>
  </div>

  <!-- Add Phone Number Modal -->
  <div *ngIf="showAddPhoneNumberModal" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
    <div class="bg-white rounded-xl shadow-xl w-full max-w-md p-6 transform transition-all duration-300 scale-95 hover:scale-100">
      <!-- Header -->
      <div class="text-center border-b pb-4">
        <h3 class="text-xl font-semibold text-gray-800">Add Phone Number to Blacklist</h3>
        <p class="text-xs text-gray-500 mt-1">Enter a phone number to add it to the blacklist.</p>
      </div>

      <!-- Input -->
      <div class="mt-5">
        <input
          type="text"
          [(ngModel)]="newPhoneNumber"
          placeholder="Enter phone number"
          class="block w-full rounded-lg border border-gray-300 focus:border-indigo-500 focus:ring focus:ring-indigo-200 px-4 py-2 text-gray-700 text-xs placeholder-gray-400"
        />
      </div>

      <!-- Buttons (Side by Side) -->
      <div class="mt-6 flex space-x-3">
        <button
          (click)="addPhoneNumber()"
          class="flex-1 py-2.5 bg-indigo-600 text-white text-base font-medium rounded-lg shadow hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition"
        >
          Add Phone Number
        </button>
        <button
          (click)="closeAddPhoneNumberModal()"
          class="flex-1 py-2.5 bg-gray-100 text-gray-700 text-base font-medium rounded-lg shadow hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300 transition"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
